import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
// import './Hospitality.css';
import './HospitalityFeatures.css';
import './WhatIsSection.css';
import './PropertyBenefits.css';
import './IntegrationShowcase.css';

const Hospitality = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [activeTab, setActiveTab] = useState('concierge');

  useEffect(() => {
    // Function to handle tab switching
    const handleTabClick = (e) => {
      if (e.target.classList.contains('tab-button')) {
        const tabId = e.target.getAttribute('data-tab');
        setActiveTab(tabId);
      }
    };

    // Add event listener to tab buttons
    document.addEventListener('click', handleTabClick);

    // Clean up event listener
    return () => {
      document.removeEventListener('click', handleTabClick);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>AI Chatbots for Hospitality & Resorts | 24/7 Guest Support</title>
        <meta
          name="description"
          content="AI assisted chatbot solutions for hotels, resorts & hospitality to enhance guest experience, automate bookings, and offer 24/7 smart concierge support."
        />
        <meta
          name="keywords"
          content="AI Chat Assist for Hospitality, ai based customer support, AI Insights, marketing campaigns with AI"
        />
        <link rel="canonical" href="https://www.aichatassist.com/industries/hospitality" />

        {/* Open Graph Meta */}
        <meta
          property="og:title"
          content="AI Chat Assist for Hotels & Resorts | 24/7 Smart Guest Help"
        />
        <meta
          property="og:description"
          content="AI chatbots for hotels, resorts & hospitality to enhance guest experience, automate bookings, handle inquiries, and deliver 24/7 concierge-style support."
        />
        <meta property="og:url" content="https://www.aichatassist.com/industries/hospitality" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://admin.aichatassist.com/uploads/Wordpress_Plugin_Banner_6964048f39.jpg"
        />
        <meta property="og:site_name" content="AI Chat Assist" />
        <meta property="og:locale" content="en_US" />

        {/* Twitter Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="AI Chat Assist for Hotels & Resorts | 24/7 Smart Guest Help"
        />
        <meta
          name="twitter:description"
          content="AI chatbots for hotels, resorts & hospitality to enhance guest experience, automate bookings, handle inquiries, and deliver 24/7 concierge-style support."
        />
        <meta
          name="twitter:image"
          content="https://admin.aichatassist.com/uploads/Wordpress_Plugin_Banner_6964048f39.jpg"
        />
        <meta name="twitter:site" content="@aichatassist" />
      </Helmet>

      {/* Hero Section */}
      <section className="hospitality-hero-section" style={{ marginTop: '-40px', paddingTop: 20 }}>
        <div className="container">
          <div className="hero-wrapper">
            <div className="hero-content">
              <h1 className="hero-heading mb-4">
                <span className="position-relative">AI Chat Assist</span>
                <span className="d-block hero-highlight">Make Every Guest Feel Special — 24/7</span>
              </h1>
              <p className="hero-description">
                Boost guest satisfaction with AI assisted chatbot solutions tailored for hotels and
                resorts. Automate bookings, respond instantly, and offer smart, multilingual service
                around the clock.
              </p>
              <div className="hero-cta mt-4">
                <a
                  href="#features"
                  className="btn px-4 py-2 rounded-pill me-3"
                  style={{
                    background: '#8c6fff',
                    color: 'white',
                    border: 'none',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background =
                      'linear-gradient(to right, #8c6fff, #ce75ff)';
                    e.currentTarget.style.borderColor = '#8c6fff';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(140, 111, 255, 0.3)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = '#8c6fff';
                    e.currentTarget.style.borderColor = '#8c6fff';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(140, 111, 255, 0.2)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  Explore Features <i className="bi bi-arrow-right"></i>
                </a>
                <a
                  href="https://app.aichatassist.com/auth/sign-up"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn px-4 py-2 rounded-pill"
                  style={{
                    background: 'transparent',
                    color: '#8c6fff',
                    border: '2px solid #8c6fff',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease, color 0.3s ease',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background =
                      'linear-gradient(to right, #8c6fff, #ce75ff)';
                    e.currentTarget.style.color = 'white';
                    e.currentTarget.style.borderColor = '#8c6fff';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(140, 111, 255, 0.3)';
                    e.currentTarget.style.transform = 'translateY(-3px)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#8c6fff';
                    e.currentTarget.style.borderColor = '#8c6fff';
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  Get Started
                </a>
              </div>
            </div>
            <div className="hero-image">
              <img
                src="/images/industries/hosbanner.png"
                alt="AI Chat Assist for Hospitality"
                className="img-fluid floating"
              />
            </div>
          </div>

          {/* Stats Section */}
        </div>
      </section>

      {/* What is AI CHAT ASSIST Section */}

      {/* Key Hospitality Features Section */}
      <section id="features" className="hospitality-features-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="section-title">
                Built for <span className="hero-highlight">Hospitality Excellence</span>
              </h2>
              <p className="section-subtitle">
                Explore how AI Chat Assist for Hospitality helps hotels and resorts deliver
                seamless, round-the-clock guest experiences
              </p>
              <div className="section-divider"></div>
            </div>
          </div>

          <div className="row feature-boxes">
            <div className="col-md-6 col-lg-3 mb-4">
              <div className="hospitality-card">
                <div className="hospitality-icon">
                  <i className="fas fa-calendar-check"></i>
                </div>
                <h3>Instant Check-In</h3>
                <p>
                  Simplify guest arrivals with AI-assisted check-in via chat. Eliminate queues and
                  start every stay with convenience.
                </p>
                {/* <div className="hospitality-tag">Popular</div> */}
              </div>
            </div>

            <div className="col-md-6 col-lg-3 mb-4">
              <div className="hospitality-card">
                <div className="hospitality-icon">
                  <i className="fas fa-globe"></i>
                </div>
                <h3>Multilingual Support</h3>
                <p>
                  Connect globally with multilingual AI Chat Assist for Hospitality. Cater to
                  international guests effortlessly.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 mb-4">
              <div className="hospitality-card">
                <div className="hospitality-icon">
                  <i className="fas fa-concierge-bell"></i>
                </div>
                <h3>24/7 Concierge</h3>
                <p>
                  Offer smart concierge support 24/7. Suggest local dining, attractions, and
                  experiences tailored to guest interests.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 mb-4">
              <div className="hospitality-card">
                <div className="hospitality-icon">
                  <i className="fas fa-utensils"></i>
                </div>
                <h3>Room Service</h3>
                <p>
                  Guests can use chat to order room service or request amenities—AI handles it all
                  smoothly and instantly.
                </p>
              </div>
            </div>
          </div>

          {/* <div className="row mt-4">
            <div className="col-12 text-center">
              <a href="#contact" className="btn btn-primary btn-lg">
                Explore All Features
              </a>
            </div>
          </div> */}
        </div>
      </section>

      {/* What is AI Chat Assist Section */}

      <section className="what-is-section">
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title">
              What is <span className="hero-highlight">AI Chat Assist</span>?
            </h2>
          </div>

          <div className="what-is-container mt-5">
            <div className="what-is-content">
              <p className="lead-text">
                AI Chat Assist for Hospitality is a smart chatbot that responds instantly to guest
                needs—whether it’s booking, room service, or concierge help. It improves guest
                satisfaction while saving time and operational costs.
              </p>

              <div className="feature-highlights-row">
                <div className="feature-card">
                  <div className="feature-icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"></path>
                      <path d="M12 6v6l4 2"></path>
                    </svg>
                  </div>
                  <div>
                    <h3>24/7 Availability</h3>
                    <p>
                      Provide round-the-clock support with AI-based customer support—no delays, no
                      downtime.
                    </p>
                  </div>
                </div>

                <div className="feature-card">
                  <div className="feature-icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4-6.2-4.5-6.2 4.5 2.4-7.4L2 9.4h7.6L12 2z"></path>
                    </svg>
                  </div>
                  <div>
                    <h3>5 Star Service</h3>
                    <p>
                      Enhance every interaction with personalized guest service backed by real-time
                      AI Insights.
                    </p>
                  </div>
                </div>

                <div className="feature-card">
                  <div className="feature-icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                  </div>
                  <div>
                    <h3>Omnichannel Support</h3>
                    <p>
                      Engage guests on every channel—web, mobile, or chat apps—with consistent,
                      branded support.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Helps Section - Redesigned with unique UI and animations */}
      <section className="property-benefits-section">
        {/* Background particles */}
        {/* <div className="property-particle property-particle-1"></div>
        <div className="property-particle property-particle-2"></div>
        <div className="property-particle property-particle-3"></div> */}

        <div className="container">
          <div className="property-benefits-header">
            <h2>
              How It Helps <span className="property-highlight">Your Property</span>
            </h2>
            <p>
              Deliver personalized, AI-driven guest services—anytime, in any language, across every
              channel
            </p>
          </div>

          <div className="property-benefits-container">
            {/* Card 1 */}
            <div className="property-benefit-card fade-in-up delay-100">
              <div className="property-benefit-icon pulse">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"></path>
                </svg>
              </div>
              <div className="property-benefit-content">
                <h3>Instant Replies – No Waiting</h3>
                <p>
                  No delays, no hold time. AI-based customer support answers guest inquiries
                  instantly, ensuring satisfaction around the clock.
                </p>
              </div>
            </div>

            {/* Card 2 */}
            <div className="property-benefit-card fade-in-up delay-200">
              <div className="property-benefit-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                </svg>
              </div>
              <div className="property-benefit-content">
                <h3>Better Guest Experience</h3>
                <p>
                  Guests can check availability, book, and make service requests—all through AI Chat
                  Assist for Hospitality, removing friction from the guest journey.
                </p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="property-benefit-card fade-in-up delay-300">
              <div className="property-benefit-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                  <line x1="1" y1="10" x2="23" y2="10"></line>
                </svg>
              </div>
              <div className="property-benefit-content">
                <h3>Easy Booking & Inquiries</h3>
                <p>
                  Automate bookings and inquiries with AI. Increase efficiency while providing
                  guests with a seamless self-service experience.
                </p>
              </div>
            </div>

            {/* Card 4 */}
            <div className="property-benefit-card fade-in-up delay-400">
              <div className="property-benefit-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                </svg>
              </div>
              <div className="property-benefit-content">
                <h3>Talks in Any Language</h3>
                <p>
                  AI Chat Assist speaks your guest’s language. Break barriers with multilingual
                  support and deliver a world-class experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Find What You Need Section
      <section className="section-padding ">
        <div className="container">
          <div className="section-header text-center mb-5">
            <h2>Find What You Need</h2>
            <p className="section-description">Discover how AI Chat Assist transforms the guest experience at every touchpoint</p>

            <div className="tab-buttons mt-4">
              <button
                className={`tab-button ${activeTab === 'concierge' ? 'active' : ''}`}
                data-tab="concierge"
                onClick={() => setActiveTab('concierge')}
              >
                In-Stay Concierge
              </button>
              <button
                className={`tab-button ${activeTab === 'checkin' ? 'active' : ''}`}
                data-tab="checkin"
                onClick={() => setActiveTab('checkin')}
              >
                Smart Check-in
              </button>
              <button
                className={`tab-button ${activeTab === 'booking' ? 'active' : ''}`}
                data-tab="booking"
                onClick={() => setActiveTab('booking')}
              >
                Booking Assistant
              </button>
            </div>


            <div className="features-tabs mt-5">
              <div className={`feature-tab ${activeTab === 'concierge' ? 'active' : ''}`} id="concierge">
                <div className="feature-tab-content">
                  <div className="feature-tab-text">
                    <h3>In-Stay Concierge via AI Chatbot</h3>
                    <p className="feature-subtitle">Your Guest's Digital Butler - Available Anytime</p>

                    <div className="feature-items">
                      <div className="feature-item">
                        <div className="feature-item-number">01</div>
                        <div className="feature-item-content">
                          <h4>Room Services</h4>
                          <p>Guests can order room service, request amenities, and more through the chatbot.</p>
                        </div>
                      </div>

                      <div className="feature-item">
                        <div className="feature-item-number">02</div>
                        <div className="feature-item-content">
                          <h4>Housekeeping</h4>
                          <p>Schedule cleaning, request additional towels or toiletries with simple chat commands.</p>
                        </div>
                      </div>

                      <div className="feature-item">
                        <div className="feature-item-number">03</div>
                        <div className="feature-item-content">
                          <h4>Service Booking</h4>
                          <p>Book spa treatments, restaurant reservations, and local activities directly in chat.</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="feature-tab-image">
                    <img src="/images/industries/concierge-feature.png" alt="In-Stay Concierge" className="img-fluid" />
                  </div>
                </div>
              </div>

              <div className={`feature-tab ${activeTab === 'checkin' ? 'active' : ''}`} id="checkin">
                <div className="feature-tab-content">
                  <div className="feature-tab-text">
                    <h3>Smart Pre Check-in</h3>
                    <p className="feature-subtitle">Faster Check-Ins, VIP Experience from the Start</p>

                    <div className="feature-items">
                      <div className="feature-item">
                        <div className="feature-item-number">01</div>
                        <div className="feature-item-content">
                          <h4>Pre-arrival Check-in</h4>
                          <p>Guests check in before arrival via chat, saving time and reducing front desk congestion.</p>
                        </div>
                      </div>

                      <div className="feature-item">
                        <div className="feature-item-number">02</div>
                        <div className="feature-item-content">
                          <h4>Automated Data Collection</h4>
                          <p>Auto-fill details from your system, eliminating repetitive form filling for guests.</p>
                        </div>
                      </div>

                      <div className="feature-item">
                        <div className="feature-item-number">03</div>
                        <div className="feature-item-content">
                          <h4>Personalized Welcome</h4>
                          <p>Create personalized greetings for returning guests based on their preferences and history.</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="feature-tab-image">
                    <img src="/images/industries/checkin-feature.png" alt="Smart Pre Check-in" className="img-fluid" />
                  </div>
                </div>
              </div>

              <div className={`feature-tab ${activeTab === 'booking' ? 'active' : ''}`} id="booking">
                <div className="feature-tab-content">
                  <div className="feature-tab-text">
                    <h3>AI Booking Assistant</h3>
                    <p className="feature-subtitle">Convert more inquiries into confirmed reservations</p>

                    <div className="feature-items">
                      <div className="feature-item">
                        <div className="feature-item-number">01</div>
                        <div className="feature-item-content">
                          <h4>Instant Availability Checks</h4>
                          <p>Answer availability questions instantly, even during peak inquiry times.</p>
                        </div>
                      </div>

                      <div className="feature-item">
                        <div className="feature-item-number">02</div>
                        <div className="feature-item-content">
                          <h4>Personalized Recommendations</h4>
                          <p>Suggest room options based on guest preferences and party size for better matches.</p>
                        </div>
                      </div>

                      <div className="feature-item">
                        <div className="feature-item-number">03</div>
                        <div className="feature-item-content">
                          <h4>Seamless Booking Process</h4>
                          <p>Process bookings directly through chat with secure payment integration.</p>
                        </div>
                      </div>

                      <div className="feature-item">
                        <div className="feature-item-number">04</div>
                        <div className="feature-item-content">
                          <h4>Upselling Opportunities</h4>
                          <p>Intelligently offer room upgrades and premium packages to increase revenue.</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="feature-tab-image">
                    <img src="/images/industries/booking-feature.png" alt="AI Booking Assistant" className="img-fluid" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Integrations Section - Modern Card Layout */}
      <section className="showcase-section">
        <div className="container">
          <div className="showcase-header">
            <h2>
              Seamless <span className="showcase-highlight">Integrations</span>
            </h2>
            <p>
              Connect AI Chat Assist with your existing hospitality systems for a unified guest
              experience
            </p>
          </div>

          <div className="showcase-container">
            {/* Card 1 - Property Management System */}
            <div className="showcase-card slide-in-up delay-100">
              <div className="showcase-badge">Popular</div>
              <div className="showcase-icon-wrapper">
                <div className="showcase-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                    <line x1="8" y1="21" x2="16" y2="21"></line>
                    <line x1="12" y1="17" x2="12" y2="21"></line>
                  </svg>
                </div>
              </div>
              <div className="showcase-content">
                <h3>Property Management System</h3>
                <p>
                  Seamlessly connect with your PMS to access real-time room data and guest
                  information
                </p>
                <div className="showcase-features">
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Real-time room availability</span>
                  </div>
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Guest profile synchronization</span>
                  </div>
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Automated booking management</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2 - Housekeeping */}
            <div className="showcase-card slide-in-up delay-200">
              <div className="showcase-icon-wrapper">
                <div className="showcase-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 3 12 9 2"></polyline>
                  </svg>
                </div>
              </div>
              <div className="showcase-content">
                <h3>Housekeeping Systems</h3>
                <p>
                  Automate room service requests and maintenance tasks through natural conversation
                </p>
                <div className="showcase-features">
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Auto-assign guest requests</span>
                  </div>
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Real-time service tracking</span>
                  </div>
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Maintenance issue reporting</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 3 - Activity Scheduling */}
            <div className="showcase-card slide-in-up delay-300">
              <div className="showcase-icon-wrapper">
                <div className="showcase-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                </div>
              </div>
              <div className="showcase-content">
                <h3>Activity Scheduling</h3>
                <p>
                  Let guests browse and book activities, spa treatments, and dining reservations
                </p>
                <div className="showcase-features">
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Real-time availability display</span>
                  </div>
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Instant booking confirmation</span>
                  </div>
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Calendar reminders for guests</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 4 - Guest Feedback */}
            <div className="showcase-card slide-in-up delay-400">
              <div className="showcase-icon-wrapper">
                <div className="showcase-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                  </svg>
                </div>
              </div>
              <div className="showcase-content">
                <h3>Guest Feedback Systems</h3>
                <p>Collect, analyze, and act on guest feedback to continuously improve service</p>
                <div className="showcase-features">
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Automated satisfaction surveys</span>
                  </div>
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Sentiment analysis reporting</span>
                  </div>
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Service recovery workflows</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 5 - Analytics */}
            <div className="showcase-card slide-in-up delay-500">
              <div className="showcase-badge">Advanced</div>
              <div className="showcase-icon-wrapper">
                <div className="showcase-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                  </svg>
                </div>
              </div>
              <div className="showcase-content">
                <h3>Analytics Dashboard</h3>
                <p>Gain actionable insights from guest interactions to optimize your services</p>
                <div className="showcase-features">
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Conversation analytics</span>
                  </div>
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Guest preference tracking</span>
                  </div>
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Custom performance reports</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 6 - Payment Processing */}
            <div className="showcase-card slide-in-up delay-600">
              <div className="showcase-icon-wrapper">
                <div className="showcase-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                    <line x1="1" y1="10" x2="23" y2="10"></line>
                  </svg>
                </div>
              </div>
              <div className="showcase-content">
                <h3>Payment Processing</h3>
                <p>
                  Enable secure transactions directly through chat with multiple payment options
                </p>
                <div className="showcase-features">
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>PCI-compliant security</span>
                  </div>
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Multiple payment methods</span>
                  </div>
                  <div className="showcase-feature-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Automated receipts & invoicing</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hospitality;
